@if (!loading) {
  <app-provider-header [provider]="provider" [showProviderDataReview]="true" />
  <div class="page-container">
    <div class="mt-3"><app-provider-detail [provider]="provider" (providerChange)="onProviderChange()"/></div>
  </div>
} @else {
  <mat-spinner />
}
